export const environment = {
    api_url: "https://notes-api.efito.xyz",
    app_url: "https://notes.efito.xyz"
};
